import { type CSSProperties } from 'react';
import { Drawer } from '@helios/ui/overlay';
import { Button } from '@helios/ui/button';
import { useBrandTokens } from '../../shell/shared';
import { SidebarPackagesPanel } from '../../shell/SidebarPackagesPanel';

// PRD.263 — Right drawer that reuses the PRD.262 Patient Packages panel from
// the global Patient Packages page. No second redemption UI — this mounts the
// exact same component the patient sidebar uses, scoped to one patient and
// optionally focused on a selected package.
interface PatientPackagesDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  patientId: string;
  patientName?: string | null;
  /** Focus/expand this package (from a table row's View/Redeem). */
  initialPatientPackageId?: string | null;
  userId?: string | null;
  isAdmin?: boolean;
  /** Navigate to the patient workspace. */
  onOpenPatient?: () => void;
}

export function PatientPackagesDrawer({
  open,
  onOpenChange,
  patientId,
  patientName,
  initialPatientPackageId = null,
  userId = null,
  isAdmin = false,
  onOpenPatient,
}: PatientPackagesDrawerProps) {
  const brandTokens = useBrandTokens();
  return (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
      title="Patient Packages"
      description={patientName ?? undefined}
      portalStyle={brandTokens as CSSProperties}
      width={480}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 'var(--sp-3)' }}>
          {onOpenPatient ? (
            <Button variant="outline" size="md" onClick={onOpenPatient}>
              Open Patient
            </Button>
          ) : (
            <span />
          )}
          <Button variant="outline" size="md" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </div>
      }
    >
      <div
        style={{
          padding: 'var(--sp-5)',
          height: '100%',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--sp-4)',
        }}
      >
        <SidebarPackagesPanel
          patientId={patientId}
          userId={userId}
          isAdmin={isAdmin}
          activeEncounterId={null}
          initialPatientPackageId={initialPatientPackageId}
        />
      </div>
    </Drawer>
  );
}
